import loadable, { LoadableComponent } from '@loadable/component';

import { WidgetType } from '../core/types/WidgetType';

const getComponent = (
  widgetType: WidgetType,
  // Needs to be any as every widget will have its own props interface
): LoadableComponent<any> | null => {
  switch (widgetType) {
    case WidgetType.BUNDLE:
      return loadable(
        () =>
          import(/* webpackChunkName: 'bundle' */ '../core/components/BundleWidget/BundleWidget'),
      );
    case WidgetType.COMPARISON:
      return loadable(
        () =>
          import(
            /* webpackChunkName: 'comparison' */ '../core/components/Comparison/Main/Comparison'
          ),
      );
    case WidgetType.DEAL:
      return loadable(
        () => import(/* webpackChunkName: 'deal' */ '../core/components/DealWidget/DealWidget'),
      );
    case WidgetType.EDITORS_PICK:
      return loadable(
        () =>
          import(
            /* webpackChunkName: 'editorspick' */ '../core/components/EditorsPick/EditorsPick'
          ),
      );
    case WidgetType.TABS:
      return loadable(
        () => import(/* webpackChunkName: 'tabs' */ '../core/components/TabsWidget/TabsWidget'),
      );
    case WidgetType.INBODY:
      return loadable(
        () => import(/* webpackChunkName: 'inbody' */ '../core/components/InBody/InBody'),
      );
    case WidgetType.LINK:
      return loadable(
        () => import(/* webpackChunkName: 'link' */ '../core/components/LinkWidget/LinkWidget'),
      );
    case WidgetType.MERCHANT_LINK:
      return loadable(() => {
        return import(
          /* webpackChunkName: 'merchantlink' */ '../core/components/MerchantLinkWidget/MerchantLinkWidget'
        );
      });
    case WidgetType.MAGAZINE_SUBSCRIPTIONS:
      return loadable(
        () =>
          import(
            /* webpackChunkName: 'magazinesubscriptions' */ '../core/components/MagazineSubscriptions/MagazineSubscriptions'
          ),
      );
    case WidgetType.MERCHANT_OVERVIEW:
      return loadable(
        () =>
          import(
            /* webpackChunkName: 'merchantoverview' */ '../core/components/MerchantOverview/MerchantOverview'
          ),
      );
    case WidgetType.MOST_POPULAR_OFFERS:
      return loadable(
        () =>
          import(
            /* webpackChunkName: 'mostpopularoffers' */ '../core/components/MostPopularOffers/MostPopularOffers'
          ),
      );
    case WidgetType.MULTI_MODEL_REVIEW:
      return loadable(
        () =>
          import(
            /* webpackChunkName: 'multimodelreview' */ '../core/components/MultiModelReview/Main/MultiModelReview'
          ),
      );
    case WidgetType.PARTNER:
      return loadable(
        () => import(/* webpackChunkName: 'partner' */ '../core/components/Partner/Partner'),
      );
    case WidgetType.PEACOCK:
      return loadable(
        () => import(/* webpackChunkName: 'peacock' */ '../core/components/Peacock/Peacock'),
      );
    case WidgetType.POCKET:
      return loadable(
        () => import(/* webpackChunkName: 'pocket' */ '../core/components/Pocket/Main/Pocket'),
      );
    case WidgetType.PPC:
      return loadable(() => import(/* webpackChunkName: 'ppc' */ '../core/components/PPC/PPC'));
    case WidgetType.PRICE:
      return loadable(
        () => import(/* webpackChunkName: 'price' */ '../core/components/Price/Main/Price'),
      );
    case WidgetType.PRODUCT_BLOCK:
      return loadable(
        () =>
          import(
            /* webpackChunkName: 'productblock' */ '../core/components/ProductBlock/ProductBlock'
          ),
      );
    case WidgetType.PRODUCT_FINDER_SEARCH:
      return loadable(
        () =>
          import(
            /* webpackChunkName: 'productfindersearch' */ '../core/components/ProductFinderSearch/ProductFinderSearch'
          ),
      );
    case WidgetType.PRODUCT_NAME:
      return loadable(
        () =>
          import(
            /* webpackChunkName: 'productname' */ '../core/components/ProductName/Main/ProductName'
          ),
      );
    case WidgetType.PROMOTION:
      return loadable(
        () => import(/* webpackChunkName: 'promotion' */ '../core/components/Promotion/Promotion'),
      );
    case WidgetType.REVIEW:
      return loadable(
        () => import(/* webpackChunkName: 'review' */ '../core/components/Review/Main/Review'),
      );
    case WidgetType.SCROLLABLE_TILE:
      return loadable(
        () =>
          import(
            /* webpackChunkName: 'scrollabletile' */ '../core/components/ScrollableTile/ScrollableTile'
          ),
      );
    case WidgetType.SEASONAL:
      return loadable(
        () => import(/* webpackChunkName: 'seasonal' */ '../core/components/Seasonal/Seasonal'),
      );
    case WidgetType.SIMPLE:
      return loadable(
        () => import(/* webpackChunkName: 'simple' */ '../core/components/Simple/Main/Simple'),
      );
    case WidgetType.SPECS:
      return loadable(
        () => import(/* webpackChunkName: 'specs' */ '../core/components/Specs/Specs'),
      );
    case WidgetType.STICKY:
      return loadable(
        () => import(/* webpackChunkName: 'sticky' */ '../core/components/Sticky/Sticky'),
      );
    case WidgetType.STREAMING:
      return loadable(
        () => import(/* webpackChunkName: 'streaming' */ '../core/components/Streaming/Streaming'),
      );
    case WidgetType.TILE:
      return loadable(() => import(/* webpackChunkName: 'tile' */ '../core/components/Tile/Tile'));
    case WidgetType.USER_REVIEWS:
      return loadable(
        () =>
          import(
            /* webpackChunkName: 'userreviews' */ '../core/components/UserReviews/UserReviews'
          ),
      );
    case WidgetType.BROADBAND:
      return loadable(
        () =>
          import(
            /* webpackChunkName: 'broadband' */ '../core/components/BroadbandWidget/BroadbandWidget'
          ),
      );
    case WidgetType.TABLETOP:
      return loadable(
        () => import(/* webpackChunkName: 'tabletop' */ '../core/components/Tabletop/Tabletop'),
      );
    case WidgetType.USER_REWARDS:
      return loadable(
        () =>
          import(
            /* webpackChunkName: 'userrewards' */ '../core/components/UserRewards/UserRewardsConnected'
          ),
      );
    case WidgetType.REWARD_NOTIFICATIONS:
      return loadable(
        () =>
          import(
            /* webpackChunkName: 'rewardnotifications' */ '../core/components/RewardNotifications/RewardNotificationsConnected'
          ),
      );
    case WidgetType.REWARD_SUMMARY:
      return loadable(
        () =>
          import(
            /* webpackChunkName: 'rewardsummary' */ '../core/components/RewardSummary/RewardSumaryConnected'
          ),
      );
    case WidgetType.EAGLE:
      return loadable(
        () => import(/* webpackChunkName: 'eagle' */ '../core/components/Eagle/Eagle'),
      );
    case WidgetType.COLLECTION:
      return loadable(
        () =>
          import(/* webpackChunkName: 'collection' */ '../core/components/Collection/Collection'),
      );
    default:
      return null;
  }
};

export default getComponent;
